import {
    Box,
    Grid,
} from "@chakra-ui/react";

import VerifyOtpForm from "./components/VerifyOtpForm";
import LoginShowcase from "../Login/components/LoginShowcase";

const VerifyOtp = () => {
    return (
        <Box
            minH="100vh"
            bg="#F8FAFC"
        >
            <Box
                w="100%"
                minH={{
                    base: "auto",
                    lg: "100vh",
                }}
                bg="white"
            >
                <Grid
                    minH={{
                        base: "auto",
                        lg: "100%",
                    }}
                    templateColumns={{
                        base: "1fr",
                        lg: "1fr 1fr",
                    }}
                >
                    <VerifyOtpForm />

                    <Box
                        order={{
                            base: 2,
                            lg: 0,
                        }}
                    >
                        <LoginShowcase />
                    </Box>
                </Grid>
            </Box>
        </Box>
    );
};

export default VerifyOtp;